import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { AdUnitPathDTO } from './types'

export const AD_UNIT_PATH_FRAGMENT = (): TypedDocumentNode<AdUnitPathDTO> => gql`
  fragment AdUnitPathFragment on AdUnit {
    id
    path
  }
`
